import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Marcas, MarcasSend } from '../_model/marcas';
import { Media } from '../_model/media';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MarcasService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/marcas/";


list() {
  return this.http.post(this.baseUrl+"list", null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
listPathOrder(path: string) {
  return this.http.post(this.baseUrl+"list/"+path, null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
listRandom() {
  return this.http.post(this.baseUrl+"list/random", null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
sendOrder(path: string,marcas: Marcas[]) {
  var array: number[] = [];
  marcas.forEach(el => {
    array.push(el.id);
  });
  var userId = localStorage.getItem("userId");
  var model: any = {
    marcas: array,
    id: userId
  };
  return this.http.post(this.baseUrl+"order/"+path, model);
}
get(id: number) {
  return this.http.post(this.baseUrl+"get/"+id, null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
send(model: MarcasSend) {
  return this.http.post(this.baseUrl+"input", model);
}
getMediaRaw(id: number) {
  return this.http.post(this.baseUrl+"media/"+id, null)
    .pipe(
      map((data: any) => {
        var result: Media[] = [];
        data.result.forEach(el => {
          result.push(new Media(el));
        });
        return result;
      })
    );
}
delete(id: number, userId: string) {
  return this.http.post(this.baseUrl+"delete/"+id, {id: userId}).pipe();
}
}
